import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchGet } from '../../api/common';
import { Profile } from '@par/shared/types/player';
import './styles.css';

type PropTypes = {
  setProfile: (profile: Profile) => void;
};

export const Verify = ({ setProfile }: PropTypes) => {
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    const verify = async () => {
      const res = await fetchGet(`/authenticate/verify/${token}`);
      if (res && res.message === 'Registration successful' && res.user) {
        setProfile(res.user as Profile);
      } else {
        navigate('/login');
      }
    };
    verify();
  }, []);

  return <></>;
};
